import { createApiCall } from "services/api/createApiCall";

import { transformUsageOverview } from "./transformations";
import { UsageOverview } from "./types";

/**
 * Pregled za gornju traku: paket, pretplata za mjesec i potrošnja do danas.
 *
 * Bez poruke o grešci: korisnik bez prava na potrošnju dobije odbijen poziv, i to je uredno
 * stanje — pokazatelj se tada jednostavno ne prikaže.
 */
export const getUsageOverviewAPI = async (): Promise<UsageOverview> => {
  const response = await createApiCall(
    {
      path: "/v1/finance/usage/current",
      method: "GET",
    },
    {
      getMessage: {
        success: () => "",
        error: () => "",
      },
    }
  )();

  return transformUsageOverview(response.data);
};
